import type { Question } from '@mentimeter/legacy-series-types/question';
import type { EditorSlide } from '../../../compatibility-overrides/editor-types';
import { UnsupportedSlidePropertyError } from '../../../backward-compatibility/errors/unsupported-slide-property-error';

export const mapEditorSlidePropertyToQuestionProperty = (
  question: Question,
  key: keyof EditorSlide,
) => {
  switch (key) {
    case 'hasComments':
      return question.has_comments;

    default:
      if (process.env.NODE_ENV === 'development') {
        const error = new UnsupportedSlidePropertyError(key);
        // eslint-disable-next-line no-console
        console.warn(error.message);
      }

      return undefined;
  }
};
